import {createRoot} from "react-dom";
import React from "react";
import {GroundReport, SnowReport} from "./components/SnowReport";

window.scripts = {};
window.getScript = function (url, callback) {
   if (!scripts[url]) {
      scripts[url] = {
         requests: [callback]
      };
      jQuery.ajax({
         dataType: 'script',
         cache: true,
         url: url,
         success: function () {
            scripts[url].ready = true;
            window.notifyScriptReady(url);
         }
      });
   } else if (scripts[url].ready) {
      setTimeout(callback, 0);
   } else {
      scripts[url].requests.push(callback);
   }
};

window.notifyScriptReady = function (url) {
   var script = scripts[url];
   if (script.ready) {
      for (var i = 0; i < script.requests.length; i++) {
         if (script.requests[i]) {
            script.requests[i].call();
         }
      }
      script.requests = [];
   }
}

window.getHSFormScript = function (callback) {
   window.getScript('https://js.hsforms.net/forms/v2.js', callback);
};

window.createHubForm = function (opts) {
   opts.portalId = '2766250';
   if (opts.deferred) {
      jQuery(window).on('load', function () {
         getHSFormScript(function () {
            hbspt.forms.create(opts);
         });
      });
   } else {
      getHSFormScript(function () {
         hbspt.forms.create(opts);
      });
   }
}

window.openHubPopUp = function (id, config) {
   var popUpSelector = '#hub-popup-' + id;
   window.hubPopUp = jQuery(popUpSelector);
   config = jQuery.extend({}, config, {
      formId: id,
      target: popUpSelector + ' .hbspt-form',
      onFormReady: function () {
         if (config && config.values) {
            var values = config.values;
            for (var key in values) {
               var input = window.hubPopUp.find('input').filter(function () {
                  return this['name'] === key;
               });
               input.val(values[key]);
            }
         }
      }
   });
   window.createHubForm(config);
   window.hubPopUp.modal('show');
};

window.isUsingDesktopMenu = function() {
   return jQuery(window).width() > 1024;
}

window.carouselGalleryDisplayedThumbs = 5;

window.onCarouselGalleryThumbClick = function(carouselId, index) {
   var carousel = jQuery('#' + carouselId),
      carouselThumb = jQuery('#' + carouselId + '-thumb'),
      carouselState = carousel.data('state') || {
         current: Math.floor(window.carouselGalleryDisplayedThumbs / 2),
         length: carousel.find('.owl-item').length
      };

   carousel.trigger('to.owl.carousel', index);
   while (index > carouselState.current) {
      carouselThumb.trigger('next.owl.carousel');
      carouselState.current++;
   }
   while (index < carouselState.current) {
      carouselThumb.trigger('prev.owl.carousel');
      carouselState.current--;
   }
   carouselState.current = Math.max(carouselState.current, Math.floor(window.carouselGalleryDisplayedThumbs / 2));
   carouselState.current = Math.min(carouselState.current, carouselState.length - Math.ceil(window.carouselGalleryDisplayedThumbs / 2));
   carousel.data('state', carouselState);
}

window.createIframe = function(config) {
   var wrapper = jQuery('#' + config.id);
   wrapper.removeAttr('onclick');
   wrapper.replaceWith('<iframe src="' + config.src + '" allow="autoplay" class="loading border-0" onload="removeLoadingSpinner(this)"></iframe>');
}

window.removeLoadingSpinner = function(el) {
   jQuery(el).removeClass('loading');
}

window.playYTVideo = function(id, videoId) {
   jQuery('#title-' + id).remove();
   createIframe({
      id: id,
      src: 'https://www.youtube.com/embed/' + videoId + '?autoplay=1'
   });
}

window.loadYTTitle = function (id, videoId) {
   var title = localStorage.getItem('yt' + videoId);
   if (title) {
      jQuery('#title-' + id).html(title);
   } else {
      jQuery.getJSON('https://noembed.com/embed?url=https://www.youtube.com/watch?v=' + videoId, function (data) {
         if (data.title) {
            jQuery('#title-' + id).html(data.title);
            localStorage.setItem('yt' + videoId, data.title);
         }
      });
   }
}

window.checkYTImageLoaded = function (img, videoId) {
   if (img.naturalHeight <= 90) {
      img.src = 'https://i.ytimg.com/vi/' + videoId + '/hqdefault.jpg';
   }
}

window.setupCollapsers = function() {
   document.querySelectorAll('.collapsable').forEach((group) => {
      const buttons = group.querySelectorAll('*[collapses]');

      buttons.forEach((el, i) => {
         el.addEventListener('click', () => {
            const target = document.querySelector('#' + el.getAttribute('collapses'));
            const isClosed = !target.classList.contains('opened');
            group.querySelectorAll('.collapse-item').forEach((el) => el.classList.remove('opened'));
            if (isClosed) {
               target.classList.add('opened');
            }
         });
      });
   });
}

window.RestAPI = (function() {
   RestAPI.base = '/wp-json/wp/v2/';

   function RestAPI() {}

   RestAPI.getPosts = function(config, callback) {
      var url = RestAPI.base + config.postType + '?';
      url += RestAPI.getFilters(config.filters);
      url += '&page=' + config.page || 1;
      url += '&per_page=' + config.perPage || 10;
      url += '&_embed';
      jQuery.get(url, callback);
   }

   RestAPI.getFilters = function(filters) {
      var html = ''
      for (var key in filters) {
         if (html) {
            html += '&';
         }
         html += 'filter[' + key + ']=' + filters[key];
      }
      return html;
   }

   return RestAPI;
})();

window.ArticlesList = (function() {
   ArticlesList.html = '' +
      '<div class="articles-list">' +
         '<ul>{list}</ul>' +
      '</div>';

   function ArticlesList(data) {
      this.data = data;
   }

   ArticlesList.prototype.toHtml = function() {
      var list = '';
      for (var i = 0; i < this.data.articles.length; i++) {
         list += new Article(this.data.articles[i]).toHtml();
      }
      return ArticlesList.html.replace('{list}', list);
   }

   return ArticlesList;
})();

window.Article = (function () {
   Article.html = '' +
      '<li>' +
        '<a class="article-image" href="{link}">' +
           '<div class="sixteen-nine-ratio">' +
              '<img src="{image}">' +
           '</div>' +
        '</a>' +
        '<div class="article-details">' +
           '<h5>' +
              '<a href="{link}">{title}</a>' +
           '</h5>' +
        '</div>' +
        '<div class="article-footer">' +
           '<p class="excerpt">{excerpt}</p>' +
           '<p class="date">{date}</p>' +
        '</div>' +
      '</li>';

   function Article(data) {
      this.data = data;
   }

   Article.prototype.toHtml = function() {
      return Article.html.
         replace(/{link}/g, this.data.link).
         replace('{title}', this.data.title.rendered).
         replace('{image}', this.getImage()).
         replace('{date}', this.getDate()).
         replace('{excerpt}', this.getExcerpt());
   }

   Article.prototype.getDate = function() {
      var date = new Date(this.data.date);

      return DateMonths[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
   }

   Article.prototype.getImage = function() {
      var image = '';
      try {
         image = this.data._embedded['wp:featuredmedia'][0].media_details.sizes.medium.source_url;
         image = image.replace('//dev', '//cdn').replace('//www', '//cdn');
      } catch(e) {};
      return image;
   }

   Article.prototype.getExcerpt = function() {
      var excerpt = this.data.excerpt.rendered,
         cutAt = excerpt.indexOf(' ', 83),
         s = '';

      if (cutAt > 0) {
         s = excerpt.substring(3, cutAt)
         s += '...';
      } else if (excerpt.length > 7) {
         s = excerpt.substring(3, excerpt.length - 5);
      }
      return s;
   }

   return Article;
})();

window.Pagination = (function() {
   function Pagination(config) {
      this.current = Number(config.current);
      this.total = Number(config.request.getResponseHeader('X-WP-TotalPages'));
      this.aroundCurrent = 2;
      this.instanceId = Pagination.instances++;
      Pagination.listeners[this.instanceId] = config.onPageChange;
   }

   Pagination.instances = 0;
   Pagination.listeners = [];

   Pagination.prototype.toHtml = function() {
      var pages = this.getPages(),
         html = '';

      for (var i = 0; i < pages.length; i++) {
         if (pages[i] === this.current) {
            html += '<span aria-current="page" class="page-numbers current">' + pages[i] + '</span>';
         } else if (pages[i] === '...') {
            html += '<span class="page-numbers">' + pages[i] + '</span>';
         } else {
            html += '<a class="page-numbers" onclick="Pagination.onPageChange(\'' + pages[i] + '\', ' + this.current + ',' + this.instanceId + ')">' + pages[i] + '</a>';
         }
      }
      return '<div class="pagination">' + html + '</div>';
   }

   Pagination.prototype.getPages = function() {
      var pages = [];
      if (this.current > 1) {
         pages.push('« Previous');
      }
      if (this.current > 1) {
         pages.push('1');
      }
      if (this.current - this.aroundCurrent > 2) {
         pages.push('...');
      }
      for (var i = this.current - this.aroundCurrent; i < this.current; i++) {
         if (i > 1) {
            pages.push(i);
         }
      }
      pages.push(this.current);
      for (var i = this.current + 1; i < this.current + this.aroundCurrent + 1; i++) {
         if (i < this.total) {
            pages.push(i);
         }
      }
      if (this.current + this.aroundCurrent < this.total - 1) {
         pages.push('...');
      }
      if (this.current < this.total) {
         pages.push(this.total);
      }
      if (this.current < this.total) {
         pages.push('Next »');
      }
      return pages;
   }

   Pagination.onPageChange = function(page, current, instanceId) {
      var listener = Pagination.listeners[instanceId];
      if (isNaN(page)) {
         if (page.indexOf('Next') !== -1) {
            listener(current + 1);
         } else {
            listener(current - 1);
         }
      } else {
         listener(page);
      }
      Pagination.listeners[instanceId] = null;
   }

   return Pagination;
})();

window.DateMonths = [
   'January',
   'February',
   'March',
   'April',
   'May',
   'June',
   'July',
   'August',
   'September',
   'October',
   'November',
   'December'
];

window.ForecastTable = class ForecastTable {
   static baseURL = 'https://www.mountainwatch.com/wp-content/themes/mountainwatch/assets/images/';

   constructor(selector, url) {
      this._container = document.querySelector(selector);
      this._container.classList.add('new-forecast');
      this._url = url;
   }

   update() {
      fetch(this._url)
         .then(response => response.json())
         .then(data => {
            this._clear();
            this._updateHTML(data)
         });
   }

   _clear() {
      while(this._container.firstChild) {
         this._container.firstChild.remove();
      }
   }

   _updateHTML(data) {
      var forecast = data[0]['DailyForecast'];
      for (var i = 0; i < forecast.length; i++) {
         this._container.append(this._getDayHtml(forecast[i]));
      }
   }

   _getDayHtml(day) {
      var wrapper = document.createElement('div');

      wrapper.classList.add('day');
      wrapper.append(this._getDayTitle(day));
      wrapper.append(this._getDayWeather(day));
      wrapper.append(this._getTemperature(day));
      wrapper.append(this._getSnowfall(day));
      return wrapper;
   }

   _getDayTitle(day) {
      var title = document.createElement('div'),
         date = new Date(day['localStartTime']).getDate();

      date = date < 10 ? '0' + date : date;
      title.classList.add('name');
      title.append(day.plainValidity + ' ' + date);
      return title;
   }

   _getDayWeather(day) {
      var weather = document.createElement('div'),
         image = document.createElement('img'),
         description = document.createElement('p'),
         data = this._getWeather(day['expectedWeatherIcon']);

      weather.classList.add('weather');
      image.setAttribute('src', ForecastTable.baseURL + data['icon']);
      description.append(data['description'])
      weather.append(image);
      weather.append(description);
      return weather;
   }

   _getTemperature(day) {
      var wrapper = document.createElement('div'),
         min = document.createElement('div'),
         max = document.createElement('div'),
         minArrow = document.createElement('img'),
         maxArrow = document.createElement('img');

      wrapper.classList.add('temperature');
      minArrow.setAttribute('src', ForecastTable.baseURL + 'arrow_weather_down.gif');
      min.append(day['minTemperature'] + ' ° ');
      min.append(minArrow);
      min.classList.add('min');
      maxArrow.setAttribute('src', ForecastTable.baseURL + 'arrow_weather_up.gif');
      max.append(day['maxTemperature'] + ' ° ');
      max.append(maxArrow);
      max.classList.add('max');
      wrapper.append(max);
      wrapper.append(min);
      return wrapper;
   }

   _getSnowfall(day) {
      var snowfall = document.createElement('div');

      snowfall.append('Snow: ' + day.Snowfall + ' cm');
      snowfall.classList.add('snowfall');
      return snowfall;
   }

   _getWeather(value) {
      var description,
         slashPosition = value.search('/'),
         icon = slashPosition > 0 ? value.substr(0, slashPosition) : value;

      switch (value) {
         case 'snowflurries':
            description = 'Snow Flurries';
            break;
         case 'snowandrain':
            description = 'Snow And Rain';
            break;
         case 'snow':
            description = 'Snow';
            break;
         case 'fine':
            description = 'Fine';
            break;
         case 'fewshowers':
            description = 'Few Showers';
            break;
         case 'partcloudy':
            description = 'Partly Cloudy';
            break;
         case 'rain':
            description = 'Rain';
            break;
         case 'cloudy':
            description = 'Cloudy';
            break;
         case 'thunder':
         case 'thunder/windy':
            description = 'Thunder Storm';
            break;
         case 'hail':
            description = 'Possible Hail';
            break;
         case 'drizzle':
            description = 'Drizzle';
            break;
         case 'fog':
            description = 'Fog';
            break;
         case 'possibleblizzard':
         case 'snow/windy':
         case 'possibleblizzard/windy':
            description = 'Possible Blizzard';
            break;
         case 'showers':
            description = 'Showers';
            break;
         case 'wind':
         case 'wind/windy':
            description = 'Windy';
            break;
         case 'snowflurries/windy':
            description = 'Windy with Flurries';
            break;
         case 'snowandrain/windy':
            description = 'Windy with Snow and Rain';
            break;
         case 'fine/windy':
            description = 'Fine but Windy';
            break;
         case 'fewshowers/windy':
            description = 'Windy with Few Showers';
            break;
         case 'partcloudy/windy':
            description = 'Partly Cloudy and Windy';
            break;
         case 'rain/windy':
            description = 'Windy with Rain';
            break;
         case 'cloudy/windy':
            description = 'Cloudy and Windy';
            break;
         case 'hail/windy':
            description = 'Windy with Possible Hail';
            break;
         case 'drizzle/windy':
            description = 'Wind and Drizzle';
            break;
         case 'fog/windy':
            description = 'Fog and Wind';
            break;
         case 'showers/windy':
            description = 'Windy with Showers';
            break;
      }
      return {
         'description': description,
         'icon': 'weather_' + icon + '.png'
      };
   }
}

window.snowReport = (elementID, resortID) => {
   const root = createRoot(document.getElementById(elementID));

   root.render(
       <SnowReport dataID={resortID}/>
   )
}

window.groundReport = (elementID, resortID) => {
   const root = createRoot(document.getElementById(elementID));

   root.render(
       <GroundReport dataID={resortID}/>
   )
}
